import Vue from "vue";
import { mapGetters } from "vuex";

import { ErrorLogService, EventTrackingService, PartDetailServices } from "@/services";

import { LoadingSpinner, StaticFormControl } from "@/components";
import { inputValidateState } from "@/components/mixins/inputValidateState";

import { default as SendError } from "../SendError.vue";
import { default as ThankYou } from "../ThankYou.vue";

import { IUserInfo } from "@/types";

export default Vue.extend({
    name: "RequestMoreInfo",
    mixins: [inputValidateState],
    components: {
        ThankYou,
        LoadingSpinner,
        SendError,
        StaticFormControl,
    },
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId", "SiteName"]),
        formIsValid(){
            return this.name && this.email && this.message;
        }
    },
    props: {
        details: {
            type: Object,
            default: () => {},
        },
        messageDefault:{
            type: String,
            default: ""
        },
        formTitleOverride:{
            type: String,
            default: ""
        }
    },

    data: () => ({
        showThankYou: false,
        showSendError: false,
        submittingForm: false,
        errorMessage: "",

        // form fields
        name: "",
        email: "",
        message: "",
    }),
    mounted(){
        this.name = this.user.FullName;
        this.email = this.user.Email;
        this.message = this.messageDefault;   
    },
    methods: {
        async submitForm() {
            try {
                this.showThankYou = false;
                this.submittingForm = true;

                var headerParams = {
                    oemPartCode: this.details.OemPartCode,
                    partDescription: this.details.PartDescription,
                    siteName: this.SiteName,
                    name: this.name,
                    email: this.email,
                    message: this.message
                }
                await PartDetailServices.sendRequestMoreInfoEmail(headerParams, this.user);

                EventTrackingService.trackEvent({
                  category: "Part Detail",
                  action: "Request More Information For Submittes",
                  label: this.details.OemPartCode,
                  value: 1,
                });

                this.showThankYou = true;
            } catch (err) {
                this.showSendError = true;
                this.errorMessage = ErrorLogService.LogAndGetErrorMessage(err);
            } finally {
                this.submittingForm = false;
            }
        },
        hideForm(){
            this.$emit("hide");
        },
        checkRequiredField(field: any, inputHasBeenVisited: boolean){
            if(!inputHasBeenVisited){
                return null;
            }
            if(field){
                return true;
            }
            return false;
        }
    }
});
